import { Input, Modal, Typography } from 'antd'
import { observer } from 'mobx-react-lite'

import { ACTIVITY_FIELD_LABELS as L, ACTIVITY_TEXT_MAX_LENGTH } from '../../Contracts/ActivityFieldLabels'

import type { CompleteActivityModalStore } from '../../Stores/CompleteActivityModalStore'

interface Props {
    store: CompleteActivityModalStore
    onConfirm: () => void
}

/**
 * «Завершити справу» (`SPEC-011` §8.5, З2): «Результат»* і дві кнопки —
 * «Завершити» / «Скасувати». Без результату під полем — текст легасі, а
 * модалка лишається відкритою (`CompleteActivityModalStore`).
 *
 * Розмітка поля — та сама, що в ядрових форм (`.form-field` +
 * `.field-label-title`): e2e знаходить його тим самим `formField`, що й поля
 * карток.
 */
export const CompleteActivityModal = observer(({ store, onConfirm }: Props) => (
    <Modal
        title="Завершити справу"
        open={store.open}
        okText="Завершити"
        cancelText="Скасувати"
        okButtonProps={{ loading: store.loading }}
        onOk={onConfirm}
        onCancel={() => store.close()}
        destroyOnHidden
        maskClosable={false}
    >
        <div className={`form-field form-field-default${store.error ? ' is-error' : ''}`}>
            <label className="field-label">
                <h2 className="field-label-title">
                    {L.result}
                    <span className="is-required">*</span>
                </h2>
            </label>
            <Input.TextArea
                rows={5}
                maxLength={ACTIVITY_TEXT_MAX_LENGTH}
                value={store.result}
                status={store.error ? 'error' : ''}
                autoFocus
                onChange={(event) => store.setResult(event.target.value)}
            />
            {store.error ? (
                <Typography.Text type="danger" role="alert">
                    {store.error}
                </Typography.Text>
            ) : null}
        </div>
    </Modal>
))
